// extracted by mini-css-extract-plugin
export default {"authLayout":"AuthSidebar_authLayout__OykB+","authSidebarLeft":"AuthSidebar_authSidebarLeft__y3gZe","circles":"AuthSidebar_circles__USNfI"};